import apiClient from './apiClient';

// ============================================================
// Types
// ============================================================

export interface QueryRequest {
  payeeFrom: string;   // 佣金受款人起始
  payeeTo: string;     // 佣金受款人結束
  salesFrom: string;   // 業務代號起始
  salesTo: string;     // 業務代號結束
  dateFrom: string;    // 交運日期起始 YYYY-MM-DD
  dateTo: string;      // 交運日期結束 YYYY-MM-DD
  shipNoFrom: string;  // 交運單號起始
  shipNoTo: string;    // 交運單號結束
  includeZero: boolean; // true=包含餘額為零, false=排除(預設)
  reportType: string;  // "payee"=受款人別, "sales"=業務別, "both"=兩者
}

export interface CommissionRow {
  fg09_01: string;   // 佣金受款人代號
  fg09_02: string;   // 出貨單號
  fg09_11: string | null; // 交運日期
  fg09_12: number;   // 應付佣金(幣別1)
  fg09_13: number;   // 已付佣金(幣別1)
  fg09_14: number;   // 預留欄(幣別1)
  fg09_15: string;   // 佣金幣別1
  fg09_22: number;   // 應付佣金(幣別2)
  fg09_23: number;   // 已付佣金(幣別2)
  fg09_24: number;   // 預留欄(幣別2)
  fg09_25: string;   // 佣金幣別2
  fc110_12: string;  // 客戶代號
  fc110_13: string;  // 業務員代號
}

export interface PayeeSummaryRow {
  payeeCode: string;
  currency: string;
  payable: number;
  paid: number;
  balance: number;
}

export interface SalesSummaryRow {
  salesCode: string;
  currency: string;
  payable: number;
  paid: number;
  balance: number;
}

export interface QueryResponse {
  details: CommissionRow[];
  payeeSummary?: PayeeSummaryRow[];
  salesSummary?: SalesSummaryRow[];
  totalCount: number;
}

export interface LookupResult {
  code: string;
  name: string;
}

// ============================================================
// API Client
// ============================================================

export const g306Api = {
  async query(req: QueryRequest): Promise<QueryResponse> {
    const res = await apiClient.post('/api/g306/query', req);
    return res.data;
  },

  async lookup(type: string, code: string): Promise<LookupResult> {
    const res = await apiClient.get(`/api/g306/lookup/${type}/${encodeURIComponent(code)}`);
    return res.data;
  },
};
